jQuery(document).ready(function () {

    const headerDefaultObserver = new IntersectionObserver(
        ([e]) => {
            e.target.classList.toggle("is-sticked", e.intersectionRatio < 1);
        },
        {threshold: [1],}
    );
    const headerDefaultElement = document.querySelector('header.header-default');
    headerDefaultObserver.observe(headerDefaultElement);

    jQuery('.header-default .header-default__burger-link').bind('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        jQuery('body, .header-default').toggleClass('is-mobile-menu-opened');
    });
});
